export class Access {
  accessToken: string;
  validSeconds: number;
  expires: Date;

  constructor(accessToken: string, validSeconds: number, expires: Date) {
    this.accessToken = accessToken;
    this.validSeconds = validSeconds;
    this.expires = expires;
  }
}
